/* eslint-disable @typescript-eslint/no-unused-vars */

import { Accordion } from '../accordion'
import { VideoModal } from '../video'
import React, { useEffect, useState } from 'react'
import { Product } from '../product'
import { ProductType, TagType } from '../../../type/menu'
import { FilterModal } from '../filterModal'
import { FilterButton } from '../filterButton'
import { filterProductByTags } from '../../../utils/filters'
import { ProductV2 } from '../product-v2'

type SubCategoryProps = {
  isLittleAddition: boolean
  title: string
  description: string
  products: ProductType[]
  hiddenProductIds: number[]
  backgroundColor?: string | null
  isOpen: boolean
  onClick: (subCategoryTitle: string | null) => void
  noMatchMessage?: string
  isArabic: boolean
}

export default function SubCategoryV2({
  title,
  isLittleAddition = false,
  description,
  products,
  hiddenProductIds,
  backgroundColor,
  isOpen = false,
  onClick,
  noMatchMessage,
  isArabic
}: SubCategoryProps) {
  const [isVideoModalOpened, setIsVideoModalOpened] = useState(false)
  const [filteredTags, setFilteredTags] = useState<{ marketingTitles: string[]; titles: string[] }>({
    marketingTitles: [],
    titles: []
  })
  const allFilteredTags = [...filteredTags.marketingTitles, ...filteredTags.titles]

  const [marketingTitles, setMarketingTitles] = useState<string[]>([])
  const [titles, setTitles] = useState<string[]>([])
  const [isFilterModalOpened, setIsFilterModalOpened] = useState(false)

  const showFilterButton = products[0].sub_category.attributes.show_filters
  const thereAreTagsToFilter = marketingTitles.length > 0 || titles.length > 0
  const numberOfActivatedTags = filteredTags.marketingTitles.length + filteredTags.titles.length
  const { products: filteredProducts, isPerfectMatch } = filterProductByTags(products, filteredTags)

  useEffect(() => {
    const filteredCategories = products.filter((category) => category.sub_category?.attributes?.title === title)
    const tags = filteredCategories.map((category) => category.product.attributes.tags).flat()
    const marketingTitles = tags.reduce((acc: string[], tag: TagType) => {
      if (acc.indexOf(tag.marketing_title) < 0) {
        acc.push(tag.marketing_title)
      }
      return acc
    }, [])
    const titles = tags.reduce((acc: string[], tag: TagType) => {
      if (acc.indexOf(tag.title) < 0) {
        acc.push(tag.title)
      }
      return acc
    }, [])

    setMarketingTitles(marketingTitles)
    setTitles(titles)
  }, [products, title])

  const showFilterModal = () => {
    setIsFilterModalOpened(true)
  }

  const handleOnFilter = ({ marketingTitles, titles }: { marketingTitles: string[]; titles: string[] }) => {
    setFilteredTags({
      marketingTitles,
      titles
    })

    const element = document.getElementById(`sub_category_${title}`)
    if (element) {
      const scroll = setTimeout(() => {
        element.scrollIntoView(true)
        clearTimeout(scroll)
      }, 10)
    }
  }

  const additionDescription = description?.split(' / ')

  return (
    <React.Fragment>
      {(!isLittleAddition && (
        <React.Fragment>
          <div className="md:col-span-2 pb-3 border-b text-left border-primary mb-1 mt-5">
            <p className="tracking-[0.02em] text-[15px] leading-none uppercase font-mammaTitle">{title}</p>
          </div>
          {filteredProducts.map((p) => {
            const isVideo = p?.product?.attributes.is_video_product
            // console.log('ICI', p)

            if (isVideo) {
              return (
                <div key={p.product.attributes.product_id}>
                  <VideoModal
                    isOpen={isVideoModalOpened}
                    closeModal={() => setIsVideoModalOpened(false)}
                    content={p?.product?.attributes.video}
                  />
                  <div className="w-full border-t border-primary">
                    <img
                      src={p?.product?.attributes?.gif}
                      alt="gif"
                      className="mx-auto my-4 cursor-pointer w-80"
                      onClick={() => setIsVideoModalOpened(true)}
                    />
                  </div>
                </div>
              )
            }

            if (hiddenProductIds?.includes(+p.product.attributes.product_id)) {
              return null
            }

            const productTitle = p.product.attributes.title?.trim()
            const productPrice = p.product.attributes.price?.trim()

            return (
              <div
                key={p.product.id}
                className={`
                      ${!productTitle && !productPrice ? 'md:col-span-2' : ''} 
                      ${p?.product?.attributes?.best_of_product && p?.product?.attributes?.image ? 'md:col-span-2' : ''}
                    `}
              >
                <ProductV2
                  hidden_products={hiddenProductIds}
                  product={p.product}
                  filteredTags={allFilteredTags}
                  isPerfectMatchFilter={isPerfectMatch}
                  isArabic={isArabic}
                />
              </div>
            )
          })}
        </React.Fragment>
      )) || (
        <div className="relative border border-primary px-3 py-6">
          <p className="absolute bg-white top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 tracking-[0.02em] text-[15px] leading-none uppercase font-mammaTitle">
            {title}
          </p>
          <div className="flex flex-wrap justify-center items-center gap-y-0.5 gap-x-2">
            <p className="text-[14px] whitespace-pre-wrap">{description}</p>
          </div>
        </div>
      )}
    </React.Fragment>
  )
}
